// APP设置页相关路由
export default {
  routes: [
    // 设置页
    {
      path: '/zzSettings/index',
      name: 'settings',
      meta: {
        auth: true,
        desc: '红包页'
      },
      component: () => import(/* webpackChunkName: "settings" */ '../views/settings/index.vue')
    }
  ]
}
